<template>
  <q-list :class="'master-maintenance ' + (mode === MODE_TYPE.SIDE ? 'listed' : 'tiled')">
    <q-item v-if="mode === MODE_TYPE.SIDE" class="master-maintenance-item">
      <span class="q-mini-drawer-hide">マスタメンテナンス</span>
    </q-item>
    <q-separator v-if="mode === MODE_TYPE.SIDE" />
    <div :class="mode === MODE_TYPE.TILE ? 'row q-mb-lg' : ''">
      <!-- SDFile一覧 -->
      <q-item v-ripple clickable :to="{ name: 'sdfile' }">
        <q-item-section>SDFile一覧</q-item-section>
      </q-item>
      <!-- SDFile登録 -->
      <q-item v-ripple clickable :to="{ name: 'sdfileRegist' }">
        <q-item-section>SDFile登録</q-item-section>
      </q-item>
    </div>
    <q-separator v-if="mode === MODE_TYPE.TILE" />
    <div :class="mode === MODE_TYPE.TILE ? 'row q-mt-lg q-mb-lg' : ''">
      <!-- 在庫価格ファイル取込 -->
      <q-item v-ripple clickable :to="{ name: 'stockPrice' }">
        <q-item-section>在庫価格ファイル取込</q-item-section>
      </q-item>
      <!--為替レート設定-->
      <q-item v-ripple clickable :to="{ name: 'exchangeRate' }">
        <q-item-section>為替レート設定</q-item-section>
      </q-item>
      <!--円転後仕入価格帯別係数設定-->
      <q-item v-ripple clickable :to="{ name: 'CoefficientSetting' }">
        <q-item-section>円転後仕入価格帯別係数設定</q-item-section>
      </q-item>
    </div>
    <q-separator v-if="mode === MODE_TYPE.TILE" />
    <div :class="mode === MODE_TYPE.TILE ? 'row q-mt-lg q-mb-lg' : ''">
      <!-- ATTOID一覧 -->
      <q-item v-ripple clickable :to="{ name: 'attoId' }">
        <q-item-section>ATTOID一覧</q-item-section>
      </q-item>
      <!-- 商品情報一覧 -->
      <q-item v-ripple clickable :to="{ name: 'catalog' }">
        <q-item-section>商品情報一覧</q-item-section>
      </q-item>
    </div>
    <q-separator v-if="mode === MODE_TYPE.TILE" />
    <div :class="mode === MODE_TYPE.TILE ? 'row q-mt-lg q-md-lg' : ''">
      <!-- サプライヤ一覧 -->
      <q-item v-ripple clickable :to="{ name: 'supplier' }">
        <q-item-section>サプライヤ一覧</q-item-section>
      </q-item>
      <!-- 得意先および掛け率一覧 -->
      <q-item v-ripple clickable :to="{ name: 'customer' }">
        <q-item-section>得意先および掛け率一覧</q-item-section>
      </q-item>
      <!-- 納期一覧 -->
      <q-item v-ripple clickable :to="{ name: 'deliveryTime' }">
        <q-item-section>納期一覧</q-item-section>
      </q-item>
      <!-- お知らせ一覧 -->
      <q-item v-ripple clickable :to="{ name: 'news' }">
        <q-item-section>お知らせ一覧</q-item-section>
      </q-item>
    </div>
  </q-list>
</template>
<script setup lang="ts">
interface Props {
  mode: string;
}
defineProps<Props>();

const MODE_TYPE = {
  SIDE: 'side',
  TILE: 'tile',
};
</script>
<style>
.master-maintenance-item span {
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
}

.master-maintenance.listed.q-list .q-item.q-router-link--active.q-link.master-maintenance-item,
.master-maintenance.listed.q-list .q-item.master-maintenance-item {
  padding: 20px 22px;
  align-items: center;
  border: none;
  color: var(--q-dark);
}

.master-maintenance.listed a.q-item {
  padding: 16px 24px;
  width: 100%;
}

.master-maintenance.listed a.q-item.q-router-link--exact-active {
  border-left: 5px solid var(--q-primary);
  padding-left: 19px;
}

.master-maintenance.listed a.q-item .q-item__section {
  font-size: 0.8rem;
}

.master-maintenance.tiled .q-item {
  width: 200px;
  border: 1px solid rgb(0 0 0 / 20%);
  border-radius: 3px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.12);
  padding: 20px 0;
  margin-right: 20px;
}

.master-maintenance.tiled .q-item__section {
  align-items: center;
}

.master-maintenance.tiled .q-gutter-sm {
  margin-top: -12px;
  margin-left: -12px;
}

.master-maintenance.tiled .q-gutter-sm {
  margin-top: 12px;
}

.master-maintenance.tiled .q-gutter-sm > * {
  margin-left: 12px;
}
</style>
